import React from "react";

import { useSignupFormDrip } from "@sp-state/useSignupFormDrip";

import styles from "./FormProgress.module.scss";

const FormProgress: React.FC = () => {
  const { progress } = useSignupFormDrip(state => state);

  const progressList =
    progress &&
    progress.map((item, idx) => (
      <div
        key={idx}
        className={`${styles.progressItem} ${item && styles.active}`}
      />
    ));

  return <div className={styles.progressList}>{progressList}</div>;
};

export default FormProgress;
